import { CountryCode } from "#/utils/CountryCode"
import { useQueryActiveSignatures, CarrotDocumentType } from "#/lib/carrot-api/signatureClient"
import { useGetIsExcludedFromMedicalRecordsConsent } from "#/services/user/hooks/useGetIsExcludedFromMedicalRecordsConsent"
import { useUserRole } from "#/components/partner-access/hooks/usePartnerAccess"
import useGetMemberCountry from "#/components/company/hooks/useGetMemberCountry"
import useGetMemberCompany from "#/components/company/hooks/useGetMemberCompany"
import { JourneyData } from "#/types/memberJourney"

export function useMeetsInitialCriteriaToShowPreservationMedicalRecordsConsent({
  routingData,
  journeyData
}: {
  routingData: { preservationInterest: string }
  journeyData: JourneyData
}): boolean {
  const memberUserCountry = useGetMemberCountry()
  const memberUserCompany = useGetMemberCompany()

  const getIsExcludedFromMedicalRecordsConsent = useGetIsExcludedFromMedicalRecordsConsent()
  const { isPartnerAccessingAccount } = useUserRole()

  const isExcludedFromMedicalRecordsConsent = getIsExcludedFromMedicalRecordsConsent({
    companyId: Number(memberUserCompany?.data?.companyId),
    parentCompanyId: memberUserCompany?.data?.parentCompanyId
  })

  return (
    memberUserCountry?.data?.countryCode === CountryCode.United_States &&
    journeyData?.journey === "PRESERVATION" &&
    !!routingData?.preservationInterest &&
    routingData?.preservationInterest !== "PRESERVE_SPERM" &&
    !isExcludedFromMedicalRecordsConsent &&
    !isPartnerAccessingAccount
  )
}

export function useShouldShowPreservationMedicalRecordsConsent({
  routingData,
  journeyData
}: {
  routingData: { preservationInterest: string }
  journeyData: JourneyData
}): {
  shouldShowPreservationMedicalRecordsConsent: boolean
  isLoadingShouldShowPreservationMedicalRecordsConsent: boolean
} {
  const meetsInitialCriteria = useMeetsInitialCriteriaToShowPreservationMedicalRecordsConsent({
    routingData,
    journeyData
  })

  const { data: activeSignatures, isFetching: isLoadingActiveSignatures } = useQueryActiveSignatures({
    enabled: meetsInitialCriteria
  })

  return {
    isLoadingShouldShowPreservationMedicalRecordsConsent: isLoadingActiveSignatures,
    shouldShowPreservationMedicalRecordsConsent:
      meetsInitialCriteria &&
      !activeSignatures?.some(
        (signature) => signature.documentType === CarrotDocumentType.FertilityPreservationConsentForm
      )
  }
}
